const cssVariableRenderer = (element, name) => (latest) => element.style.setProperty(name, latest);
const styleRenderer = (element, name) => (latest) => (element.style[name] = latest);

export { cssVariableRenderer, styleRenderer };
